import { useState } from 'react';
import { Row, Col, Form, Input, FormInstance, Checkbox, Modal } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import Switch from '../../Molecules/Switch/Switch';
import TaskType from '../../../models/TaskType';
import { rolePermissions } from '../../../utils/utils';
import './RolForm.less';

/**
 * @component RolForm.tsx
 * @description RolForm component to create and edit a rol.
 * @return { Component }
 */
interface RolFormProps {
  form: FormInstance;
  tasksType: TaskType[];
  isEdit: boolean;
  rolDelete: () => void;
}
function RolForm(props: RolFormProps) {
  const [isAvailable, setIsAvailable] = useState(false);
  const { confirm } = Modal;
  const isEnabled = (enable: boolean) => {
    setIsAvailable(enable);
    props.form.setFieldsValue({
      activo: enable,
    });
  };
  const roleDelete = () => {
    confirm({
      title: '¿Quieres eliminar el rol?',
      icon: <ExclamationCircleOutlined />,
      content: (
        <>
          Esta acción lo eliminará por completo <br /> y es irreversible.
        </>
      ),
      okText: 'Eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      cancelButtonProps: {
        style: {
          color: '#262626',
          lineHeight: '22px',
        },
      },
      onOk() {
        props.rolDelete();
      },
    });
  };
  return (
    <div className="org-rol-form">
      <Row>
        <Col span={24}>
          <Form layout={'vertical'} form={props.form} name="RolForm">
            <Form.Item
              name={'rol'}
              label="Nombre del Rol"
              style={{fontWeight: 'bold'}}
              rules={[
                {
                  required: true,
                  message: 'Ingresa un nombre para el Rol',
                },
              ]}
            >
              <Input
                size="large"
                required
                placeholder={'Ingresa un nombre para el Rol'}
                className="org-rol__input"
              />
            </Form.Item>
            <Form.Item
              name={'tipotareaId'}
              label={<div style={{fontWeight: 'bold'}}>Asociar tipos de tareas:</div>}
              rules={[
                {
                  required: true,
                  message: 'Selecciona un tipo de tarea',
                },
              ]}
            >
              <Checkbox.Group>
                <Row>
                  <Col>
                    {props.tasksType.map((item) => (
                      <Checkbox
                        value={item.id}
                        key={item.id}
                        className="org-rol-form__check__box"
                      >
                        {item.tipotarea}
                      </Checkbox>
                    ))}
                  </Col>
                </Row>
              </Checkbox.Group>
            </Form.Item>
            <Form.Item
              name={'permiso'}
              label={
                props.isEdit
                  ? <div style={{fontWeight: 'bold'}}>Configura el permiso del Rol:</div>
                  : <div style={{fontWeight: 'bold'}}>Agregar permiso:</div>
              }
              rules={[
                {
                  required: true,
                  message: 'Selecciona el permiso de rol.',
                },
              ]}
            >
              {rolePermissions()}
            </Form.Item>
            {props.isEdit && (
              <Form.Item name="activo" className="org-rol-form__switch">
                <Switch value={isAvailable} isEnabled={isEnabled} />
              </Form.Item>
            )}
            {props.isEdit && (
              <div className="org-task-form__delete">
                <div className="icon-delete" onClick={roleDelete}>
                  <DeleteOutlined /> Eliminar
                </div>
              </div>
            )}
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default RolForm;
